import { render, staticRenderFns } from "./QuestionCorrectRoute.vue?vue&type=template&id=47c2faa9&scoped=true&"
import script from "./QuestionCorrectRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionCorrectRoute.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCorrectRoute.vue?vue&type=style&index=0&id=47c2faa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2faa9",
  null
  
)

export default component.exports